import { NestedMenuItem } from "@kaltura/ds-react-components";
import { ChevronRight16Icon } from "@kaltura/ds-react-icons";
import { usePublishMenuItems, PublishMenuItemsProps } from "../../../publish/publish-menu/usePublishMenuItems";
import { useMediaQuery, useTheme } from "@mui/material";

export interface PublishMenuItemProps extends PublishMenuItemsProps {
    label: string;
}

/**
 * publish menu item
 * used in:
 * media page action, my-media single entry action, my-media bulk action (mobile)
 */
export function PublishMenuItem(props: PublishMenuItemProps) {
    const { label, autoFocus, tabIndex, ...rest } = props;
    const theme = useTheme();
    const isScreenLarge = useMediaQuery(theme.breakpoints.down("xl")); // screen width <= 1536px

    const items = usePublishMenuItems(rest);

    return (
        <NestedMenuItem
            key={"publish"}
            label={label}
            icon={<ChevronRight16Icon />}
            autoFocus={autoFocus}
            tabIndex={tabIndex}
            openOnClick={true}
            {...(isScreenLarge ? { anchorOrigin: { vertical: "bottom", horizontal: "left" } } : {})}
        >
            {items}
        </NestedMenuItem>
    );
}

export default PublishMenuItem;
